export const Eye = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 11.5L20.4544 11.7087C20.5152 11.5762 20.5152 11.4238 20.4544 11.2913L20 11.5ZM20 11.5C20.4544 11.7087 20.4543 11.7089 20.4542 11.7091L20.4539 11.7097L20.4532 11.7112L20.4511 11.7156L20.4442 11.7304C20.4382 11.7429 20.4298 11.7604 20.4188 11.7827C20.3969 11.8272 20.3648 11.8908 20.3225 11.9706C20.2378 12.1303 20.1119 12.3555 19.9437 12.6244C19.608 13.1614 19.1008 13.8778 18.4139 14.5957C17.0415 16.0298 14.9196 17.5 12 17.5C9.08036 17.5 6.95848 16.0298 5.58612 14.5957C4.89917 13.8778 4.39204 13.1614 4.0563 12.6244C3.88815 12.3555 3.76221 12.1303 3.67753 11.9706C3.63518 11.8908 3.60309 11.8272 3.58116 11.7827C3.57019 11.7604 3.56176 11.7429 3.55584 11.7304L3.54886 11.7156L3.54678 11.7112L3.54609 11.7097L3.54584 11.7091C3.54573 11.7089 3.54564 11.7087 4 11.5M20 11.5C20.4544 11.2913 20.4543 11.2911 20.4542 11.2909L20.4539 11.2903L20.4532 11.2888L20.4511 11.2844L20.4442 11.2696C20.4382 11.2571 20.4298 11.2396 20.4188 11.2173C20.3969 11.1728 20.3648 11.1092 20.3225 11.0294C20.2378 10.8697 20.1119 10.6445 19.9437 10.3756C19.608 9.83855 19.1008 9.12217 18.4139 8.40431C17.0415 6.9702 14.9196 5.5 12 5.5C9.08036 5.5 6.95848 6.9702 5.58612 8.40431C4.89917 9.12217 4.39204 9.83855 4.0563 10.3756C3.88815 10.6445 3.76221 10.8697 3.67753 11.0294C3.63518 11.1092 3.60309 11.1728 3.58116 11.2173C3.57019 11.2396 3.56176 11.2571 3.55584 11.2696L3.54886 11.2844L3.54678 11.2888L3.54609 11.2903L3.54584 11.2909C3.54573 11.2911 3.54564 11.2913 4 11.5M4 11.5L3.54564 11.7087C3.48479 11.5762 3.48479 11.4238 3.54564 11.2913L4 11.5Z"
      stroke="#8791A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse cx="11.9994" cy="11.5" rx="2.66667" ry="2.75" stroke="#8791A3" />
  </svg>
)

export const EyeHidden = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.612 19.6847L17.612 3.68472"
      stroke="#8791A3"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4841 5.35519C13.7276 5.13172 12.8999 5 12 5C8.89757 5 6.6538 6.5654 5.22488 8.05862C4.50887 8.80685 3.98146 9.5521 3.63234 10.1105C3.45722 10.3906 3.3254 10.6262 3.23582 10.7951C3.191 10.8796 3.15663 10.9476 3.13261 10.9964C3.12059 11.0208 3.11115 11.0404 3.10427 11.0549L3.09587 11.0727L3.0931 11.0787L3.09207 11.0809L3.09164 11.0818C2.96994 11.3468 2.96994 11.6532 3.09164 11.9182L3.09207 11.9191L3.0931 11.9213L3.09587 11.9273L3.10427 11.9451C3.11115 11.9596 3.12059 11.9792 3.13261 12.0036C3.15663 12.0524 3.191 12.1204 3.23582 12.2049C3.3254 12.3738 3.45722 12.6094 3.63234 12.8895C3.98146 13.4479 4.50887 14.1932 5.22488 14.9414C5.58433 15.317 5.99534 15.6972 6.45862 16.0559L7.05852 15.256C4.98532 13.6451 4 11.5 4 11.5C4 11.5 6.52632 6 12 6C12.6545 6 13.2668 6.07863 13.8377 6.21709L14.4841 5.35519ZM12.3021 8.26458C12.2026 8.25493 12.1016 8.25 11.9994 8.25C10.2361 8.25 8.83276 9.71969 8.83276 11.5C8.83276 11.8957 8.90209 12.2761 9.02929 12.6283L9.83342 11.5562C9.83298 11.5375 9.83276 11.5188 9.83276 11.5C9.83276 10.4169 10.5634 9.5301 11.5216 9.30521L12.3021 8.26458ZM14.0851 10.8872L14.785 9.954C15.0284 10.4151 15.1661 10.9423 15.1661 11.5C15.1661 13.2803 13.7627 14.75 11.9994 14.75C11.7427 14.75 11.4937 14.7189 11.2554 14.6601L11.9387 13.7491C11.9589 13.7497 11.9791 13.75 11.9994 13.75C13.1817 13.75 14.1661 12.7573 14.1661 11.5C14.1661 11.287 14.1378 11.0815 14.0851 10.8872ZM9.74802 16.67L9.11401 17.5154C9.97656 17.8166 10.938 18 12 18C15.1024 18 17.3462 16.4346 18.7751 14.9414C19.4911 14.1932 20.0185 13.4479 20.3677 12.8895C20.5428 12.6094 20.6746 12.3738 20.7642 12.2049C20.809 12.1204 20.8434 12.0524 20.8674 12.0036C20.8794 11.9792 20.8889 11.9596 20.8957 11.9451L20.9041 11.9273L20.9069 11.9213L20.9087 11.9174C20.9089 11.917 20.9087 11.9174 20 11.5C20.9087 11.0826 20.9089 11.083 20.9087 11.0826L20.9069 11.0787L20.9041 11.0727L20.8957 11.0549C20.8889 11.0404 20.8794 11.0208 20.8674 10.9964C20.8434 10.9476 20.809 10.8796 20.7642 10.7951C20.6746 10.6262 20.5428 10.3906 20.3677 10.1105C20.0185 9.5521 19.4911 8.80685 18.7751 8.05862C18.3349 7.59859 17.8173 7.1317 17.2212 6.70585L16.6212 7.50584C18.9133 9.1342 20 11.5 20 11.5C20 11.5 17.4737 17 12 17C11.1844 17 10.4342 16.8779 9.74802 16.67ZM20.9087 11.0826L20 11.5L20.9087 11.9174C21.0304 11.6524 21.0304 11.3476 20.9087 11.0826ZM3.09164 11.9182C3.09146 11.9178 3.09128 11.9174 4 11.5L3.09164 11.9182ZM4 11.5L3.09164 11.0818C3.09146 11.0822 3.09128 11.0826 4 11.5Z"
      fill="#8791A3"
    />
  </svg>
)

export const ArrowIconActive = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.82083 0.154202L5 3.97504L1.17917 0.154202L0 1.33337L5 6.33337L10 1.33337L8.82083 0.154202Z"
      fill="#525E72"
    />
  </svg>
)

export const ArrowIconInactive = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 0.666634L0 5.66663L1.17917 6.8458L5 3.02497L8.82083 6.8458L10 5.66663L5 0.666634Z"
      fill="#525E72"
    />
  </svg>
)

export const CheckmarkWhite = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49999 9.47504L2.02499 6.00004L0.845825 7.17921L5.49999 11.8334L15.5 1.83337L14.3208 0.654205L5.49999 9.47504Z"
      fill="white"
    />
  </svg>
)
